import { createFileRoute, Outlet } from "@tanstack/solid-router";
import { ProjectShell } from "~/components/layout/ProjectShell";
import { useProjectQuery } from "~/lib/queries/projects";

export const Route = createFileRoute("/_authenticated/projects/$projectId")({
  ssr: false,
  component: ProjectLayout,
  staticData: {
    hideGlobalSidebar: true,
  },
});

function ProjectLayout() {
  const params = Route.useParams();
  const projectQuery = useProjectQuery(() => params().projectId);

  return (
    <ProjectShell
      projectId={params().projectId}
      projectName={projectQuery.data?.name}
      isLoading={projectQuery.isPending}
    >
      <Outlet />
    </ProjectShell>
  );
}
